import { Outlet } from "react-router-dom";
import { Header } from "../header/header";
import Footer from "../Footer/Footer";
import { useAuth } from "../../auth/AuthContext";

export function AppLayout() {
    const { user, userAuthenticated, login, logout } = useAuth();

    return (
        <div style={{ padding: "0px 0px 60px 0px" }}>
            <Header user={user} userAuthenticated={userAuthenticated} loginCallback={login} logoutCallback={logout} />
            <Outlet />
            <Footer />
        </div>
    );
}
